import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { Membership } from "./membership.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class MembershipApiFacade extends AccountObjectApiFacade<Membership> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Membership> {
        return this.GET(`/accounts/${accountId}/memberships/${id}`, options)
            .map(object => new Membership(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Membership>> {
        return this.CGET(`/accounts/${accountId}/memberships`, options)
            .map(objects => objects.map(object => new Membership(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership/membership.api-facade.ts